var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZooom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#FEE7EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 5.25V6.75H6V9.75H4.5V5.25H9ZM4.5 18.75V14.25H6V17.25H9V18.75H4.5ZM19.5 18.75H15V17.25H18V14.25H19.5V18.75ZM19.5 9.75H18V6.75H15V5.25H19.5V9.75Z",
    fill: "#E60A2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZooom);
export default __webpack_public_path__ + "static/media/zooom.af6fb0208e286525414e852659f151c5.svg";
export { ForwardRef as ReactComponent };